import { InvoiceManagementInvoiceFormType } from '../forms/invoice/types';
import { useInvoiceDataConfirmation } from '../invoice/hooks/useInvoiceDataConfirmation';

type Props = {
  onSuccess?: (id: string) => void;
  onError?: (status: number) => void;
  onValidationError?: () => void;
};
export const useConfirmInvoiceManagementInvoiceForm = ({ onSuccess, onError, onValidationError }: Props) => {
  const {
    createInvoiceManagementInvoice,
    updateInvoiceManagementInvoice,
    state: { isLoading, isReady },
  } = useInvoiceDataConfirmation({
    onSuccess: (id) => onSuccess?.(id),
    onError: (status) => onError?.(status),
  });

  const onFormSubmit = (data: InvoiceManagementInvoiceFormType) => {
    try {
      createInvoiceManagementInvoice({
        ...data,
      });
    } catch (e) {
      console.error(e);
      onValidationError?.();
    }
  };

  return {
    onFormSubmit,
    updateInvoiceManagementInvoice,
    state: {
      isLoading,
      isReady,
    },
  };
};
